/* eslint-disable react-hooks/rules-of-hooks */
import { browserInit as segment } from '@rategravity/frontend/modules/segment';
import {
  identify as identifyAction,
  pageViewObservable
} from '@rategravity/frontend/modules/user-actions';
import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, IndexRoute, Redirect, Route, Router, withRouter } from 'react-router';
import Rx from 'rxjs/Rx';
import '@rategravity/frontend/theme/index.styl';
import { clearSession, setSessionValue } from './components/card/session-card';
import RelayEnvironment from './components/relay-environment';
import { getAuthToken, initializeSession, isAnonToken, setAuthToken } from './modules/authenticate';
import { parseHashParams } from './modules/parse-hash-params';
import Affordability from './products/affordability';
import Preapproval from './products/preapproval';
import Purchase from './products/purchase';
import Qualify from './products/qualify';
import RefiFull from './products/refi-full';
import RefiQualify from './products/refi-qualify';
import './index.styl';

const actionPipe = new Rx.ReplaySubject(10);
// Route page-view actions to the action pipe
pageViewObservable(browserHistory).subscribe(actionPipe);

// Create unique event names for question view/answer before
// passing to segment as this facilitates funnel creation
const transformedPipe = actionPipe.map(({ id, properties = {}, ...action }) => {
  const { questionId, ...props } = properties;
  return id === 'ViewQuestion' || id === 'SubmitAnswer'
    ? { id: `${id}-${questionId}`, properties: props, ...action }
    : { id, properties, ...action };
});
segment(transformedPipe);

const onEnterRoot = async (nextState, _, callback) => {
  const useToken = (token) => {
    RelayEnvironment.resetWithToken(token);
    actionPipe.next(identifyAction(token));
    callback();
  };

  // Check the URL for a userId.
  // This will exist if the user has been redirected
  // to this questionnaire from the onboarding application.
  const { userId } = parseHashParams();

  if (window.location.href.indexOf('#') > -1) {
    history.replaceState(history.state, document.title, window.location.href.split('#')[0]);
  }

  // Prefer the userId from the URL hash parameters
  // over any id token they may already have in session.
  if (userId && isAnonToken(userId)) {
    setAuthToken(userId);
    useToken(userId);
    return;
  }

  const token = getAuthToken();
  if (token && isAnonToken(token)) {
    useToken(token);
  } else {
    const newToken = await initializeSession();
    setAuthToken(newToken);
    useToken(newToken);
  }
};

const AppRoot = class extends React.Component {
  componentWillUnmount() {
    RelayEnvironment.reset();
  }

  render() {
    return this.props.children;
  }
};

const Resume = class extends React.Component {
  componentWillMount() {
    const { userId, email, name, path = '' } = JSON.parse(
      decodeURIComponent(atob(this.props.params.link))
    );

    clearSession();
    setAuthToken(userId);
    setSessionValue('borrower', 'email', email);
    setSessionValue('borrower', 'name', name);
    RelayEnvironment.resetWithToken(userId);
    this.props.router.replace(`/${path}`);
  }

  render() {
    return null;
  }
};

ReactDOM.render(
  <RelayEnvironment>
    <Router history={browserHistory}>
      <Route path="/login" onEnter={() => location.replace('https://www.ownup.com')} />
      <Route path="/login/:link" component={withRouter(Resume)} />
      <Route path="/" onEnter={onEnterRoot} component={AppRoot}>
        <IndexRoute onEnter={() => location.replace('https://discover.ownup.com/get-started')} />
        {Preapproval({ path: 'preapproval', actionPipe })}
        {Qualify({ path: 'qualify', actionPipe })}
        {Purchase({ path: 'purchase', actionPipe })}
        {RefiFull({ path: 'refinance-full', actionPipe })}
        {RefiQualify({ path: 'refinance-qualify', actionPipe })}
        {Affordability({ path: 'affordability', actionPipe })}
        <Redirect from="*" to="/" />
      </Route>
    </Router>
  </RelayEnvironment>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js